import PropTypes from 'prop-types'
import { useState, useEffect, useRef, useCallback } from 'react'
import './indicarEtiquetas.css'

const MAX_TAG_LENGTH = 14

const IndicarEtiquetas = (props) => {
  const [tags, setTags] = useState([])
  const tagInputRef = useRef(null)

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setTags(props.value.split('|'))

      if (props.value === '') {
        setTags([])
      }
    }
  }, [props.value])

  const eliminarTag = useCallback(
    (i) => {
      setTags((prevTags) => {
        const newTags = [...prevTags]
        newTags.splice(i, 1)
        const tagsString = newTags.join('|')
        props.onChangeState('etiquetas', tagsString)
        return newTags
      })
    },
    [props]
  )

  const handleKeyDown = (e) => {
    const val = e.target.value
    if (tags.length > MAX_TAG_LENGTH) {
      tagInputRef.current.value = null
      return false
    }
    if ((e.key === 'Enter' && val) || (e.key === ',' && val) || (e.key === ';' && val)) {
      if (tags.find((tag) => tag.toLowerCase() === val.toLowerCase())) {
        return
      }
      setTags((prevTags) => {
        const newTags = [...prevTags, val]
        props.onChangeState('etiquetas', newTags.join('|'))
        tagInputRef.current.value = null
        return newTags
      })
    } else if (e.key === 'Backspace' && !val) {
      eliminarTag(tags.length - 1)
    }
  }

  return (
    <>
      {!props.vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Usando estas etiquetas los interesados podrán encontrar más fácilmente tu
          producto. Tenés un máximo de 15 etiquetas.
        </p>
      )}
      <div className="input-tag">
        <ul className="input-tag__tags">
          {tags.map((tag, i) => (
            <span className="badge badge-tab" key={tag}>
              {tag}
              <button
                type="button"
                className="delete-tab"
                onClick={() => {
                  eliminarTag(i)
                }}
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </span>
          ))}
          <li className="input-tag__tags__input">
            <input
              type="text"
              name="etiquetas"
              onKeyDown={handleKeyDown}
              ref={tagInputRef}
            />
          </li>
        </ul>
      </div>
    </>
  )
}

IndicarEtiquetas.propTypes = {
  value: PropTypes.string,
  onChangeState: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default IndicarEtiquetas
